<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
    >
      Loading...
    </div>
    <div v-else-if="eventData">
      <div class="d-flex justify-content-between align-items-center">
        <div class="font-weight-bold h5">
          {{ offerName }}
        </div>
        <div class="text-muted">
          <i class="fas fa-users mr-1" />
          {{ presentCount }} / {{ totalCount }}
        </div>
      </div>

      <div class="h6 font-weight-bold pb-2 text-primary">
        {{ formattedDay }}
      </div>

      <div class="mt-2">
        <div class="font-weight-bold">
          Godzina
        </div>
        <div>{{ formattedFrom }} - {{ formattedTo }}</div>
      </div>
      <div class="mt-2 mb-4">
        <div class="font-weight-bold">
          Opis
        </div>
        <div>
          {{ eventData.description }}
        </div>
      </div>

      <div class="mt-2">
        <div class="font-weight-bold mb-3">
          Uczestnicy
        </div>
        <ul class="list-group">
          <li
            v-for="payer in eventData.payers"
            :key="payer.id"
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center">
              <i
                v-if="eventData.participantIds.includes(payer.id)"
                class="fas fa-check-square text-success mr-2"
              />
              <i
                v-else
                class="fas fa-times-square text-muted mr-2"
              />
              {{ payer.name }}
            </div>
            <div>
              <span
                v-if="payer.isPaid"
                class="small text-muted"
              >
                <i class="fas fa-dollar-sign text-success mr-1" />
                Zapłacone
              </span>
              <span
                v-else
                class="small text-muted"
              >
                <i class="fas fa-dollar-sign text-danger mr-1" />
                Niezapłacone
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      Error loading event data.
    </div>

    <div class="mt-2">
      <button
        class="btn btn-danger"
        :disabled="!eventData"
        @click="removeEvent"
      >
        <i class="fas fa-trash pr-2" />
        Usuń wydarzenie
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
  props: {
    eventId: String,
    catalogId: String,
    offerName: String,
  },
  data() {
    return {
      eventData: null,
      loading: true,
    };
  },
  components: {},
  computed: {
    formattedDay() {
      if (!this.eventData) return '';
      return moment.utc(this.eventData.from).format('dddd, D MMMM YYYY');
    },
    formattedFrom() {
      if (!this.eventData) return '';
      return moment.utc(this.eventData.from).format('HH:mm');
    },
    formattedTo() {
      if (!this.eventData) return '';
      return moment.utc(this.eventData.to).format('HH:mm');
    },
    presentCount() {
      return this.eventData ? this.eventData.participantIds.length : 0;
    },
    totalCount() {
      return this.eventData ? this.eventData.payers.length : 0;
    },
  },
  methods: {
    ...mapActions('shop', [
      'getCalendarEvent',
      'removeCalendarEvent',
    ]),
    removeEvent() {
      this.removeCalendarEvent({
        params: {
          catalogId: this.catalogId,
          eventId: this.eventId,
          offerId: this.eventData.offerId,
        },
      })
        .then(() => {
          this.$emit('refresh');
        });
    },
  },
  mounted() {
    this.getCalendarEvent({
      params: {
        catalogId: this.catalogId,
        eventId: this.eventId,
      },
    })
      .then((response) => {
        this.eventData = response.data;
      })
      .catch(() => {
        this.eventData = null;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
